import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Timeline from "./components/Timeline/Timeline";
const App = () => {
    return (_jsx("div", { className: "app", children: _jsx(Timeline, {}) }));
};
export default App;
